import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    private secretKey: string = '4DE2EAFC5BDBE5F011EA7D9C12216CF7CE4ECF4A1F4064CAFFB0E29186BE26B2';

    public saveData(key: string, value: string, storage = localStorage): void {
        storage.setItem(key, this.encrypt(value));
    }

    public getData(key: string, storage = localStorage): string | null {
        let data = storage.getItem(key) || '';
        return this.decrypt(data) || null;
    }

    public removeData(key: string, storage = localStorage): void {
        storage.removeItem(key);
    }

    public clearData(storage = localStorage): void {
        storage.clear();
    }

    private encrypt(txt: string): string {
        return CryptoJS.AES.encrypt(txt, this.secretKey).toString();
    }

    private decrypt(txtToDecrypt: string): string {
        return CryptoJS.AES.decrypt(txtToDecrypt, this.secretKey).toString(CryptoJS.enc.Utf8);
    }
}
